module.exports = {"id":"227638","name":"Suleiman Abdullahi","rating":"71","photo":"./data/images/photos/3/227638.png","club":{"name":"Eint. Brunswick","logo":"./data/images/clubs/Eint.Brunswick.png"},"positions":["BU","AG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SuleimanAbdullahi0.json
// module id = 4053
// module chunks = 0